import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { BsPlusCircleFill } from "react-icons/bs";
import { CiEdit } from "react-icons/ci";
import { RiDeleteBin5Line, RiGalleryUploadLine } from "react-icons/ri";
import { LiaEyeSlashSolid, LiaEyeSolid } from "react-icons/lia";
import { ImUpload2 } from "react-icons/im";
import { RiUploadCloud2Fill } from "react-icons/ri";

import { GoUpload } from "react-icons/go";
import { json } from "stream/consumers";
import { RiRestartFill } from "react-icons/ri";

import { RiDeleteBin5Fill } from "react-icons/ri";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import { IoArrowUndoCircleOutline } from "react-icons/io5";


interface UserStructure {
  profile: string;
  id: number;
  name: string;
  email: string;
  delete: number;
  role:string;
  designation:string;
  company_name:string;
  point:number;
}

interface UserDetails {
  id: number;
  name: string;
  email: string;
  role: string;
  company_name: string;
  profile: string;
  point :number;
  Time :string;
  DOB:string;
  password: string;
  a_auth_code_yr4_ign: string;
  designation:string;

}


interface ReportStructure {
  InitiatedBy: number;
  approve: string;
  date: string;
  discussion_point: string;
  id: number;
  image: string;
  location: string;
  meetingWith: number;
  type: string;
}

interface ReferenceStructure {
  id: number;
  referenceTo: number;
  referenceBy: number;
  RefPerName: string;
  number: string;
  date: string;
}

interface NewsStructure {
  id: string;
  title: string;
  img: string;
  desc: string;
  date: string;
  PresentMember:string;
}
interface pointstruc{
  id:number;
  type:string;
  data:number
}
const Member = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const [selectedImagePath, setSelectedImagePath] = useState<string | null>(
    null
  );

  const handleImageSelect = (path: string) => {
    setSelectedImagePath(path); // Save the selected path in the parent component
    // //console.log("Selected Image Path:", path);
  };

  const closegallery = () => {
    setGallery(false);
  };

  const [searchNotFound, setSearchNotFound] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [resetUser, setResetUser] =  useState<number | any>(null);
  const [newData, setNewData] = useState<UserStructure[]>([]);

  const [gallery, setGallery] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showBlocked, setShowBlocked] = useState(false);

  const handleSearch = async () => {
    // //console.log("Searching for:", searchQuery);

    try {
      // Make sure the searchQuery is not empty before making the request
      if (!searchQuery) {
        alert("Please enter a search term");
        return;
      }

      // Sending a GET request to the backend with the search query
      const response = await axios.get(
        `${api}/auth/member/search/${searchQuery}`
      );
      // //console.log("user data", response.data);
      setNewData(response.data);

      // Log the response data for debugging
      //console.log("Search results:", response.data);
      setSearchNotFound("");
      // Handle the data (e.g., updating state, displaying results)
      // For example, you could update the state here
      // setSearchResults(response.data);
    } catch (error) {
      setSearchNotFound("Not Found");
      console.error("Error during search:", error);
    }
  };

  // Open modal
  const openModal = (postId: number) => {
    setSelectedUserId(postId);
    setIsModalOpen(true);
  };

  // Function to close modal and clear the post ID
  const closeModal = () => {
    setSelectedUserId(null);
    setIsModalOpen(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<UserStructure[]>(
          `${api}/auth/allusersinfo`
        );

        //console.log("news data", response.data);
        setNewData(response.data);
        //console.log("user data in a array", newData);
      } catch (error) {
        console.error("user Not Found:", error);
      }
    };

    fetchData();
  }, []);





  function deletePost(id: number): void {
    const confirmation = window.confirm(
      "Are you sure you want to delete this member?"
    );

    if (confirmation) {
      axios
        .delete(`${api}/auth/member/${id}`)
        .then((response) => {
          
          alert("Post deleted successfully");
         
          window.location.reload();
        })
        .catch((error) => {
          // Handle errors
         
          alert("Failed to delete the post. Please try again.");
        });
    }
  }


  const handleResetClick = (userId: number) => {
    setResetUser(userId); // Set the selected user's ID
    // Perform any additional logic here
    // console.log(`Reset points for User ID: ${userId}`);
  };
  return (
    <div>
      {/* news header  */}
      <div
        className="flex flex-wrap justify-between items-center sticky top-0 z-10 px-2  w-full left-0 right-0 lg:h-[74px] h-[110px]" 
        style={{
          WebkitBackdropFilter: "blur(22px)",
          backdropFilter: "blur(22px)",
        }}
      >
        <div className="flex items-center gap-4">
        <div
          className="flex justify-between cursor-pointer h-[45px] px-2 py-2 bg-[#FDBC12] text-darkblue items-center rounded-lg gap-2"
          onClick={() => openModal(-1)}
        >
          <BsPlusCircleFill /> <h6>Add New</h6>
        </div>
        <div
          className="flex justify-between cursor-pointer h-[45px] px-2 py-2 bg-red-600 text-gray-100 items-center rounded-lg gap-2"
          onClick={() => setShowBlocked(!showBlocked)}
        >
          <RiDeleteBin5Fill /> <h6>View Trash</h6>
        </div>
        </div>
        
        

        <div>
          <div className="bg-transparent border h-[45px] border-darkblue px-2 rounded-lg flex justify-between items-center text-darkblue">
            <input
              type="search"
              name="search"
              id=""
              className="placeholder-darkblue border-none outline-none bg-transparent"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Write here...."

            />
            <button
              className="cursor-pointer px-2 border-l border-darkblue h-full flex items-center justify-center"
              onClick={handleSearch} // You can define a handleSearch function to perform the search
            >
              Search
            </button>
          </div>
          {searchNotFound && <p className="text-red-500">{searchNotFound}</p>}
        </div>
      </div>

      <div>
      {showBlocked && (
          <div className="fixed inset-0 flex items-center justify-center  bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg w-[50%] h-auto relative pt-10">
              {/* Close button */}
              <button onClick={()=>setShowBlocked(!showBlocked)} className="text-red-500 font-bold bg-gray-100 rounded-full absolute top-4 right-4 p-1">
         <IoArrowBackCircleSharp/>
       </button>
              <BlockUserModal  onClose={()=>setShowBlocked(!showBlocked)} />
            </div>
          </div>
        )}
        {isModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg w-[50%] h-auto">
              {/* Close button */}
              {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
         X
       </button> */}
              <Modal userId={selectedUserId} onClose={closeModal} />
            </div>
          </div>
        )}
        <div className="px-2 py-3 overflow-x-auto">
       <table className="table-auto w-full border-collapse border bg-white border-gray-300">
  <thead className="text-white bg-darkblue">
    <tr>
      <th className="border-y border-y-gray-300 px-4 py-2 text-left">Name</th>
      
      <th className="border-y border-y-gray-300 px-4 py-2 text-left">Classification</th>
      <th className="border-y border-y-gray-300 px-4 py-2 text-left">Company Name</th>
      <th className="border-y border-y-gray-300 px-4 py-2 text-left">Role</th>
      <th className="border-y border-y-gray-300 px-4 py-2 text-left">Point</th>
      <th className="border-y border-y-gray-300 px-4 py-2 text-left"></th>
    </tr>
  </thead>
  <tbody>
    {newData.length > 0 ? (
      newData.filter((items)=>items.role!=='super-admin').map((item) => (
        <tr key={item.id} className="border border-gray-300">
          <td className=" px-4 py-2 flex gap-3">
            <img
              className="h-[60px] object-cover w-[60px] rounded-full"
              src={
                item.profile
                  ? item.profile.startsWith("http")
                    ? item.profile
                    : `${api}/${item.profile}`
                  : "https://via.placeholder.com/150"
              }
              alt={item.name || "Image"}
            />
            <div>
              <h3 className="font-semibold">{item.name}</h3>
              <h3 className="font-normal text-xs text-gray-500">{item.email}</h3>
              </div>
          </td>
          
          <td className="border-y border-y-gray-300 px-4 py-2">{item.designation}</td>
          <td className="border-y border-y-gray-300 px-4 py-2">{item.company_name}</td>
          <td className="border-y border-y-gray-300 px-4 py-2">{item.role}</td>
          <td className="border-y border-y-gray-300 px-4 py-2">{item.point}</td>
          <td className="border-y border-y-gray-300 px-4 py-2">
            <div className="flex gap-4">
              <button
                className="flex items-center gap-2 px-3 py-1 border border-darkblue text-darkblue rounded-lg hover:bg-darkblue hover:text-white"
                onClick={() => openModal(item.id)}
              >
                <CiEdit />
              </button>
              <button
                className="flex items-center gap-2 px-3 py-1 border border-red-600 text-red-600 rounded-lg hover:bg-red-600 hover:text-white"
                onClick={() => deletePost(item.id)}
              >
                <RiDeleteBin5Line /> 
              </button>
              <button
                className="flex items-center gap-2 px-3 py-1 border border-green-400 text-green-500 rounded-lg hover:bg-green-500 hover:text-white"
                onClick={() => handleResetClick(item.id)}
              >
                <RiRestartFill /> 
              </button>
            </div>
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={7} className="text-center py-4">
          Loading...
        </td>
      </tr>
    )}
  </tbody>
</table>
</div>
{resetUser!=null && (
        <div>
          <ResetPoint usersId={resetUser} onClose={()=>setResetUser(null)}/>
        </div>
      )}
      </div>
    </div>
  );
};

interface ModalProps {
  userId?: number | null;
  onClose: () => void;
}

// Decrypt function
const Modal: React.FC<ModalProps> = ({ userId, onClose }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false); // State for dropdown menu visibility
  const api = process.env.REACT_APP_API_URL as string;
  const dropdownRef = useRef<HTMLDivElement | null>(null); // Type the ref here
  // Reference for the dropdown menu

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [selectedImagePath, setSelectedImagePath] = useState<string | null>(
    null
  );

  const handleImageSelect = (path: string) => {
    setSelectedImagePath(path); // Save the selected path in the parent component
    // setFormData((prev) => ({ ...prev, image:  }));
    setFileName(path);
    //console.log("Selected Image Path:", path);
  };

  const closegallery = () => {
    setGallery(false);
  };

  const [gallery, setGallery] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const formatDate = (isoDate: string): string => {
    const date = new Date(isoDate);
    return date.toISOString().split("T")[0]; // Extracts yyyy-MM-dd
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    role: "",
    company_name: "",
    designation: "",
    image: null as File | null,
    password: "",
    DOB:"",
    Time:"",
    username:"",
    number: 0,
  });
  const [fileName, setFileName] = useState<string | null>(null);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (userId != -1) {
      const fetchPost = async () => {
        try {
          const response = await axios.get(
            `${api}/auth/user/${userId}`
          );

          const data = Array.isArray(response.data)
            ? response.data[0]
            : response.data;
          // Access the first element

          console.log('user data from one id',data);   
          // Destructure from the first element of the array
          const {
            name,
            email,
            role,
            company_name,
            designation,
            profile: image,
            password,
            a_auth_code_yr4_ign,
            DOB,
            Time,
            username,
            number,
          } = data;

          //console.log("name:", name);
          //console.log("email:", email);
          //console.log("role:", role);
          //console.log("company_name:", company_name);
          //console.log("image path: ", image);

          const smptextpsd = 	a_auth_code_yr4_ign.slice(3, -3);
          const jsdate = formatDate(DOB);
          const jstime = formatDate(Time);

          setFormData({
            name,
            email,
            role,
            company_name,
            designation,
            password:smptextpsd,
            username,
            image: image || null,
            DOB:jsdate,
            Time:jstime,
            number
          });

          setFileName(image);
        } catch (err) {
          console.error("Error fetching users:", err);
        }
      };
      fetchPost();
    }
  }, [userId]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setFormData((prev) => ({ ...prev, image: file }));
    setFileName(file ? file.name : null);
    setSelectedImagePath(file ? file.name : null);
  };

  const closeGallery = () => {
    setGallery(false);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate fields
    if (!formData.name || !formData.password || !formData.email) {
      setError("All fields are required.");
      return;
    }

    const data = new FormData();
    data.append("name", formData.name);
    data.append("company_name", formData.company_name);
    data.append("designation", formData.designation);
    data.append("email", formData.email);
    data.append("role", formData.role);
    data.append("password", formData.password);
    data.append("username", formData.username);
    data.append("DOB",formData.DOB);
    data.append("number",String(formData.number));
    data.append("Time",formData.Time);
    if (formData.image) {
      data.append("image", formData.image);
    } else if (fileName) {
      data.append("image", fileName);
    }

    try {
      if (userId != -1) {
        await axios.put(`${api}/auth/member/${userId}`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
       
      } else {
        await axios.post(`${api}/auth/member`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        
      }
      onClose();
      window.location.href = "/dashboard";
    } catch (err) {
      
      setError("Failed to submit the post. Please try again.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white lg:w-1/2 md:w-[75%] w-[96%] p-6 rounded shadow relative h-[96%] overflow-y-auto">
        <form onSubmit={handleSubmit} className="space-y-4 grid ">
          <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-2">
            <div>
              <label className="text-[#030303] font-medium"> Member Name</label>
              <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter memeber name..."
                  className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[14px]"
                  required
                />
              </div>
            </div>

            <div>
              <label className="text-[#030303] font-medium">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                placeholder="Enter email"
                required
              />
            </div>
            <div>
              <label className="text-[#030303] font-medium">Date Of Birth</label>
              <input
                type="date"
                name="DOB"
                value={formData.DOB}
                onChange={handleChange}
                className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                
                required
              />
            </div>
            <div>
              <label className="text-[#030303] font-medium">Mobile Number</label>
              <input
                type="number"
                name="number"
                value={formData.number}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,12}$/.test(value)) {
                    handleChange(e);
                  }
                }}
                className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                placeholder="Enter mobile number"
                required
                size={10}
                maxLength={10}
              />
            </div>
            <div>
              <label className="text-[#030303] font-medium">Date Of Joining</label>
              <input
                type="date"
                name="Time"
                value={formData.Time}
                onChange={handleChange}
                className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                
                required
              />
            </div>
            <div>
              <label className="text-[#030303] font-medium">Classification</label>
              <input
                type="text"
                name="designation"
                value={formData.designation}
                onChange={handleChange}
                className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                placeholder="Enter designation"
                required
              />
            </div>

            <div>
              <label className="text-[#030303] font-medium">Role</label>
              <select
                className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                value={formData.role} // Bind to state
                onChange={
                  (e) => setFormData({ ...formData, role: e.target.value }) // Update the role in state
                }
              >
                <option value="" disabled>
    Select Role
  </option>
                <option value="Member">Member</option>
                <option value="Leader">Leader</option>
                <option value="Coordinator">Coordinator</option>
              </select>
            </div>
            <div>
              <label className="text-[#030303] font-medium">Company Name</label>
              <input
                type="text"
                name="company_name"
                value={formData.company_name}
                onChange={handleChange}
                className="mt-1 mb-4 p-2 block  h-[50px] w-full border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                placeholder="Enter company name"
                required
              />
            </div>
            <div>
              <label className="text-[#030303] font-medium">Username</label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                className="mt-1 mb-4 p-2 block  h-[50px] w-full border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                placeholder="Enter username"
              
                required
              />
            </div>
            <div className="relative">
              <label className="text-[#030303] font-medium">
                Enter Password
              </label>
              <input
                type={showPassword ? "text" : "password"}
                name="password" // Added name attribute for FormData
                className="w-full border  h-[50px] p-2 rounded mt-1"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter member password"
                required
              />
              <div className="absolute top-[57%] right-3 transform -translate-y-1/2 cursor-pointer">
                {!showPassword ? (
                  <LiaEyeSlashSolid onClick={() => setShowPassword(true)} /> // Show password icon
                ) : (
                  <LiaEyeSolid onClick={() => setShowPassword(false)} /> // Hide password icon
                )}
              </div>
            </div>
          </div>
          {/* File Upload */}
         
         
          <div className="hidden">
            <label className="text-[#030303] font-medium">
              Add Profile Photo
            </label>
            <div className="mt-1 w-[100%] h-[160px] border-dashed px-2 border-[2px] border-[#94A2B8] rounded-lg flex flex-col justify-center items-center mb-4">
              {/* Icon for file upload */}
              <RiGalleryUploadLine
                size={24}
                className="text-[30px] cursor-pointer"
                onClick={() => document.getElementById("file-upload")?.click()}
              />
              <input
                id="file-upload"
                type="file"
                accept="image/*"
                className="hidden"
                name="image"
                onChange={handleFileChange}
              />

              {/* Choose Media from Library */}
              <div className="flex flex-col items-center">
                <button
                  type="button"
                  className="mt-2 flex items-center space-x-2 text-blue-500 hover:underline"
                  onClick={() => setGallery(true)}
                >
                  Choose Media From Library <ImUpload2 className="text-2xl" />
                </button>
              </div>

              {/* Modal for Gallery */}
              {gallery && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-lg w-[50%] h-auto p-4 relative">
                    {/* GalleryModal with close button */}
                    <GalleryModal
                      onImageSelect={handleImageSelect}
                      onClose={closeGallery}
                    />
                    <button
                      className="absolute top-2 right-2 text-red-500 text-xl"
                      onClick={closeGallery}
                    >
                      X
                    </button>
                  </div>
                </div>
              )}

              {/* Display selected file or gallery image */}
              {selectedImagePath ? (
                <div className="mt-4">
                  <p className="text-[14px] text-[#02256d]">
                    Selected image:{" "}
                    <span className="font-bold">{selectedImagePath}</span>
                  </p>
                  <img
                    src={`${api}/${selectedImagePath}`}
                    alt="Selected"
                    className="w-24 h-24 rounded-md mt-2 object-cover"
                  />
                </div>
              ) : fileName ? (
                <p className="text-[14px] text-[#02256d] mt-2">
                  Selected file: <span className="font-bold">{fileName}</span>
                </p>
              ) : (
                <p className="font-bold text-[14px]">
                  Drag and Drop or{" "}
                  <span className="text-[#02256d]">click to upload</span>
                </p>
              )}
            </div>
          </div>

          <div className="relative">
            <label className="text-[#030303] font-medium">
              Add Profile Photo
            </label>
            <div className="mt-1 w-[100%] h-[120px] border-dashed px-2 border-[2px] border-[#94A2B8] rounded-lg flex flex-col justify-center items-center cursor-pointer mb-4 relative" onClick={()=>setDropdownOpen((prev) => !prev)}>
              {/* Select Image button */}
              <button
                type="button"
                className="text-[30px] cursor-pointer"
               
              >
                <RiUploadCloud2Fill />             
              </button>

              {/* Dropdown menu for selecting Upload or Gallery */}
              {dropdownOpen && (
                <div
                  ref={dropdownRef}
                  className="absolute top-[70px] right-32 w-auto bg-white border border-gray-300 rounded-md shadow-lg z-10"
                >
                  <ul>
                    <li
                      className="p-2 cursor-pointer flex gap-2 justify-center items-center hover:bg-gray-200"
                      onClick={() =>
                        document.getElementById("file-upload")?.click()
                      }
                    >
                      Upload File <GoUpload/>
                    </li>
                    <li
                      className="p-2 cursor-pointer hover:bg-gray-200"
                      onClick={() => setGallery(true)}
                    >
                      Choose from Gallery
                    </li>
                  </ul>
                </div>
              )}

              {/* File upload input */}
              <input
                id="file-upload"
                type="file"
                accept="image/*"
                className="hidden"
                name="image"
                onChange={handleFileChange}
              />

              {/* Gallery modal */}
              {gallery && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-lg w-[50%] h-auto p-4 relative">
                    <GalleryModal
                      onImageSelect={handleImageSelect}
                      onClose={closeGallery}
                    />
                    <button
                      className="absolute top-2 right-2 text-red-500 text-xl"
                      onClick={closeGallery}
                    >
                      X
                    </button>
                  </div>
                </div>
              )}

              {/* Display selected file or gallery image */}
              {selectedImagePath ? (
                <div className="mt-4">
                  <p className="text-[14px] text-[#02256d]">
                    Selected image:{" "}
                    <span className="font-bold">{selectedImagePath}</span>
                  </p>
                  {/* <img
                    src={`${api}/${selectedImagePath}`}
                    alt="Selected"
                    className="w-24 h-24 rounded-md mt-2 object-cover"
                  /> */}
                </div>
              ) : fileName ? (
                <p className="text-[14px] text-[#02256d] mt-2">
                  Selected file: <span className="font-bold">{fileName}</span>
                </p>
              ) : (
                <p className="font-bold text-[14px]">
                  Choose media{" "}
                  {/* <span className="text-[#02256d]">click to upload</span> */}
                </p>
              )}
            </div>
          </div>

          {/* Error Message */}
          {error && <p className="text-red-500">{error}</p>}

          <div className=" flex justify-between">
            {/* Date */}

            <div className="flex items-center">
              {/*Cancel form button*/}
              <button
                className="mt-[22px] mx-[10px] border-[#94A2B8] border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-semibold"
                onClick={onClose}
              >
                Cancel
              </button>
              {/* Submit Button */}
              <button
                type="submit"
                className="mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold"
                disabled={
                  !formData.password || !formData.name || !formData.email
                }
              >
                {userId != -1 ? "Update profile" : "Add User"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
interface Gallery {
  id: number;
  name: string;
  path: string;
}

interface GalleryModalProps {
  onImageSelect: (path: string) => void; // Callback function to return selected image path
  onClose: () => void;
}

const GalleryModal: React.FC<GalleryModalProps> = ({
  onImageSelect,
  onClose,
}) => {
  const [mediaData, setMediaData] = useState<Gallery[]>([]);
  const [selected, setSelected] = useState("");
  const api = process.env.REACT_APP_API_URL as string;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${api}/auth/media`);

        if (Array.isArray(response.data.data)) {
          setMediaData(response.data.data);
        } else {
          console.error("Response is not an array:", response.data);
        }
      } catch (error) {
        console.error("Error fetching media data:", error);
      }
    };

    fetchData();
  }, []);

  const handleImageSelect = (path: string) => {
    onImageSelect(path); // Pass the selected image path to the parent component
    setSelected(path);
  };

  return (
    <div className="p-4">
      <h1 className="text-lg font-bold mb-4">Choose media from here</h1>
      {mediaData.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-2 h-[340px] overflow-y-auto">
          {mediaData.map((imagedata) => (
            <div
              className={`w-full aspect-square border cursor-pointer ${
                selected && imagedata.path === selected
                  ? "border-2 border-blue-500 opacity-35"
                  : ""
              }`}
              key={imagedata.id}
              onClick={() => handleImageSelect(imagedata.path)}
            >
              <img
                src={`${api}/${imagedata.path}`}
                alt={imagedata.name || "Media item"}
                className="object-cover w-full h-full rounded-md shadow-md"
              />
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-gray-500">
          No media available to display.
        </p>
      )}
      <div
        className="w-[90px] h-[45px] bg-blue-500 text-white flex justify-center items-center rounded mt-2 cursor-pointer"
        onClick={onClose}
      >
        Select file
      </div>{" "}
      {selected}
    </div>
  );
};


interface UserDetailsOfIdProps {
  usersId: number;
  onClose: () => void;
}

const ResetPoint: React.FC<UserDetailsOfIdProps> = ({ usersId, onClose }) => {
  const api = process.env.REACT_APP_API_URL as string;

  const [pointdata, setPointdata] = useState<pointstruc[]>([]);
  const [userdetails, setUserdetails] = useState<UserDetails | null>(null);
  const [usersData, setUsersData] = useState<UserDetails[]>([]);
  const [reportData, setReportData] = useState<ReportStructure[]>([]);
  const [referenceData, setReferenceData] = useState<ReferenceStructure[]>([]);
  const [newData, setNewData] = useState<NewsStructure[]>([]);
  const [finalresult, setFinalresult] = useState<number | null>(null);

  // Fetch Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [points, news, references, reports, users] = await Promise.all([
          axios.get(`${api}/auth/point`),
          axios.get(`${api}/auth/news`),
          axios.get(`${api}/auth/reference`),
          axios.get(`${api}/auth/memeberpoint`),
          axios.get(`${api}/auth/allusersinfo`),
        ]);

        setPointdata(points.data.data);
        setNewData(Array.isArray(news.data) ? news.data : [news.data]);
        setReferenceData(references.data.data);
        setReportData(reports.data);
        setUsersData(users.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [api]);

  // Update User Details
  useEffect(() => {
    const selectedUser = usersData.find((user) => user.id === usersId);
    if (selectedUser) {
      setUserdetails(selectedUser);
    }
  }, [usersId, usersData]);

  // Calculation Functions
  const calculateR2RPoints = (
    reportData: ReportStructure[],
    pointdata: pointstruc[],
    userdetails: UserDetails
  ) => {
    const initiatedByCount = reportData.filter(
      (items) => items.InitiatedBy === userdetails.id && items.type === "R2R"
    ).length;

    const r2rHostSum = pointdata
      .filter((items) => items.type === "R2RHost")
      .reduce((sum, item) => sum + item.data, 0);

    const meetingWithCount = reportData.filter(
      (items) => items.meetingWith === userdetails.id && items.type === "R2R"
    ).length;

    const r2rGuestSum = pointdata
      .filter((items) => items.type === "R2RGuest")
      .reduce((sum, item) => sum + item.data, 0);

    return initiatedByCount * r2rHostSum + meetingWithCount * r2rGuestSum;
  };

  const calculateVisitorPoints = (
    reportData: ReportStructure[],
    pointdata: pointstruc[],
    userdetails: UserDetails
  ) => {
    const visitorCount = reportData.filter(
      (items) => items.InitiatedBy === userdetails.id && items.type === "Visitor"
    ).length;

    const visitorPoints = pointdata
      .filter((items) => items.type === "R2RHost")
      .reduce((sum, item) => sum + item.data, 0);

    return visitorCount * visitorPoints;
  };

  const calculateReferencePoints = (
    referenceData: ReferenceStructure[],
    pointdata: pointstruc[],
    userdetails: UserDetails
  ) => {
    const referenceCount = referenceData.filter(
      (items) => items.referenceBy === userdetails.id
    ).length;

    const referencePoints = pointdata
      .filter((items) => items.type === "Reference")
      .reduce((sum, item) => sum + item.data, 0);

    return referenceCount * referencePoints;
  };

  const calculatePresentPoints = (
    newData: NewsStructure[],
    pointdata: pointstruc[],
    userdetails: UserDetails
  ) => {
    const calculateAttendance = (status: string) =>
      newData.reduce((count, items) => {
        const presentMembers = items.PresentMember
          ? JSON.parse(items.PresentMember)
          : [];
        return presentMembers.some(
          (pid: any) => pid.id === userdetails.id && pid.status === status
        )
          ? count + 1
          : count;
      }, 0);

    const totalPresence = calculateAttendance("present");
    const totalLate = calculateAttendance("late");
    const totalSubstitute = calculateAttendance("substitute");

    const attendancePoints = pointdata
      .filter((items) => items.type === "Attendance")
      .reduce((sum, item) => sum + item.data, 0);

    const latePoints = pointdata
      .filter((items) => items.type === "Late")
      .reduce((sum, item) => sum + item.data, 0);

    const substitutePoints = pointdata
      .filter((items) => items.type === "Substitute")
      .reduce((sum, item) => sum + item.data, 0);

    return (
      totalPresence * attendancePoints +
      totalLate * latePoints +
      totalSubstitute * substitutePoints
    );
  };

  // Final Calculation
  useEffect(() => {
    if (userdetails) {
      const result =
        calculateR2RPoints(reportData, pointdata, userdetails) +
        calculateVisitorPoints(reportData, pointdata, userdetails) +
        calculateReferencePoints(referenceData, pointdata, userdetails) +
        calculatePresentPoints(newData, pointdata, userdetails);

      setFinalresult(result);
      const updateUserPoints = async () => {
        try {
          await axios.put(`${api}/auth/updateuserpoint/${usersId}`, {
            point: result,
          });
          console.log("User points updated successfully");
        } catch (error) {
          console.error("Error updating user points:", error);
        }
      };

      updateUserPoints();
      onClose(); // Close the modal
    }
  }, [userdetails, pointdata, reportData, referenceData, newData, onClose]);

  return null;
};


interface BlockUserModalProps {
  onClose: () => void;
}

// Decrypt function
const BlockUserModal: React.FC<BlockUserModalProps> = ({onClose }) => {
  const api = process.env.REACT_APP_API_URL as string;
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const [blockData, setBlockData] = useState<UserStructure[]>([]);



  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<UserStructure[]>(
          `${api}/auth/deleteduser`
        );

        //console.log("news data", response.data);
        setBlockData(response.data);
        //console.log("user data in a array", newData);
      } catch (error) {
        console.error("user Not Found:", error);
      }
    };

    fetchData();
  }, []);

  const [formData, setFormData] = useState({
  });
  const [fileName, setFileName] = useState<string | null>(null);





  const [loadingId, setLoadingId] = useState<number | null>(null); // Manages loading state for each user

  const Unblock = async (id: number) => {
    setLoadingId(id); // Set loading state for the clicked button

    try {
      await axios.put(`${api}/auth/getbackdeleteduser/${id}`, {}, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Successfully unblocked!");
      setBlockData((prev) => prev.filter((user) => user.id !== id)); // Remove unblocked user from the list
    } catch (err) {
      alert("Unable to unblock user. Please try again.");
    } finally {
      setLoadingId(null); // Reset loading state
    }
  };
  const removeUser = (id: any) => {
    setBlockData(blockData.filter((user) => user.id !== id));
  };

  return (
    <div className="px-2 py-3 overflow-x-auto">
      <div className="max-w-3xl mx-auto bg-white">
      {blockData.length > 0 ? (
        <ul className="space-y-3">
          {blockData.filter((user) => user.role !== "super-admin").map((user) => (
            <li key={user.id} className="flex items-center justify-between p-3 border-b border-gray-300">
              <div className="flex items-center gap-4">
                <img
                  className="h-12 w-12 rounded-full object-cover"
                  src={
                    user.profile
                      ? user.profile.startsWith("http")
                        ? user.profile
                        : `${api}/${user.profile}`
                      : "https://via.placeholder.com/150"
                  }
                  alt={user.name || "Profile"}
                />
                <div>
                  <h3 className="font-semibold text-gray-900">{user.name}</h3>
                  <p className="text-sm text-gray-500">{user.email}</p>
                </div>
              </div>

              <button
                className="flex items-center gap-2 px-3 py-1 border border-green-600 text-green-600 rounded-lg hover:bg-green-600 hover:text-white transition disabled:opacity-50"
                onClick={() => Unblock(user.id)}
                disabled={loadingId === user.id} // Disable button while loading
              >
                {loadingId === user.id ? "Unblocking..." : <IoArrowUndoCircleOutline />}
                {loadingId === user.id ? "" : "Unblock"}
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-center text-gray-500">No blocked users found.</p>
      )}
    </div>
</div>
  );
};
export default Member;
